import { render, staticRenderFns } from "./MultiAnswerQuestion.vue?vue&type=template&id=2a2009c4&scoped=true"
import script from "./MultiAnswerQuestion.vue?vue&type=script&lang=js"
export * from "./MultiAnswerQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultiAnswerQuestion.vue?vue&type=style&index=0&id=2a2009c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2009c4",
  null
  
)

export default component.exports